import Companylogo from "../CSDLogo.svg";
import Sitelogo from "../Sitelogo.svg";

const GlobalData = {
  company: {
    companyName: "Derma Slim & Wellness",
    companyPhone: "+918977733001",
    companyEmail: "wecare@dermaslimwellness.com",
    companyAddress: "DermaSlim Wellness, 1st Floor, Old Jail Road, Above Pages Book Shop, Opp SBI Bank, Rednam Alcazar, Rednam Gardens, Ram Nagar, Visakhapatnam, Andhra Pradesh - 530002",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=918977733001",

    companyfacebook: "https://www.facebook.com/dermaslim_wellness_vizag/",
    companyinstagram: "https://www.instagram.com/dermaslim_wellness_vizag/",
    companygit: "https://github.com/dermaslim_wellness_vizag/",
    companytwitter: "https://twitter.com/dermaslim_wellness_vizag/",
  },

  /*Developed and Designed by */
  cyberspacedigital: {
    companyName: "Cyber Space Digital",
    companyPhone: "+918143407758",
    companyEmail: "mail@cyberspacedigital.in",
    companyAddress: "Visakhapatnam, Andhra Pradesh 530017",
    companyWhatsapp: "https://api.whatsapp.com/send?phone=918143407758",

    companyfacebook: "https://www.facebook.com/cyber.space.digital/",
    companyinstagram: "https://www.instagram.com/cyber.space.digital/",
    companygit: "https://github.com/akhilthej/",
    companytwitter: "https://twitter.com/CyberSD1995/",
  },
};

export { GlobalData, Companylogo, Sitelogo };
